import { PartnerModel } from '@/types/models/partners';
import InputEntity from '@/lib/formFactory/inputEntity';
import CheckboxEntity from "@/lib/formFactory/checkboxEntity";
import ImageEntity from "@/lib/formFactory/imageEntity";
import SelectEntity from "@/lib/formFactory/select/entity";

export default class EntityModel {
    model: PartnerModel;

    constructor() {
        const group = new SelectEntity('group')
            .setTitle('Группа')
            .setRequired(true)

        const partnerName = new InputEntity('partnerName');
        partnerName.setTitle('Имя партнера');
        partnerName.setRequired(true);

        const title = new InputEntity('title');
        title.setTitle('Название предложения');
        title.setRequired(true);

        const description = new InputEntity('description');
        description.setTitle('Описание предложения');
        description.setRequired(true);

        const offer = new InputEntity('offer');
        offer.setTitle('Предложение');
        offer.setRequired(true);

        const condition = new InputEntity('condition');
        condition.setTitle('Условия получения');
        condition.setRequired(true);

        const sort = new InputEntity('sort');
        sort.setTitle('Сортировка');
        sort.setRequired(true);

        const availableTypes = new CheckboxEntity('isActive');
        availableTypes.setName('Активность');

        const image = new ImageEntity('image');
        image.setTitle('Фотография');
        image.setKey('image-input');
        image.setRequired(true);

        this.model = {
            group: group.entity,
            partnerName: partnerName.entity[partnerName.entityName],
            title: title.entity[title.entityName],
            description: description.entity[description.entityName],
            offer: offer.entity[offer.entityName],
            condition: condition.entity[condition.entityName],
            sort: sort.entity[sort.entityName],
            isActive: availableTypes.entity,
            image: image.entity[image.entityName],
            addresses: [],
            phones: [],
        };
    }
}
